import { Container, Form, Button } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useHistory } from "react-router-dom";
import ResultHandler from "../../../../components/ResultHandler";
import { addInvoice } from "../../../../api/invoices";
import * as Yup from "yup";
import FormButtonHandler from "../../../../components/FormButtonHandler";
import { useResponse } from "../../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { MEDIA_FIELDS } from "./CONSTANT";
import InvoiceForm from "./InvoiceForm";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

const TYPES = {
  select: null,
  "add-more": [],
  checkbox: false,
  file: null,
  date: null,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

function getValidationRules(type) {
  return MEDIA_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "";
    if (f.type == "file") {
      FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
        "This Field Is Required"
      );
    } else {
      FIELDS_VALIDATION[f.key] = Yup.string().required(
        "This Field Is Required"
      );
    }
  });
}

const AddInvoice = () => {
  const { t } = useTranslation();
  let navigate = useHistory();

  ///// get pool

  const { contractId } = useParams();

  const { setData, loading, error, success } = useResponse(addInvoice, () => {
    navigate.goBack();
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object(getValidationRules()),
    onSubmit: (data) => {
      setData({ data, type: "add" });
    },
  });

  const handlePreviewClick = () => {
    if (validation.values.contracts.length < 1) {
        toast.error("Please select a contract");
    } else if(validation.values.contracts.length !== 1) {
        toast.error("Please select only one contract");
    } else{
        const contractId = validation.values.contracts?.[0];
        navigate.push(`/invoices/preview/${contractId}`);
    }
  };

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Invoices")}
            breadcrumbItem={t("Add Invoice")}
          />

          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <InvoiceForm contractId={contractId} validation={validation} />

            <FormButtonHandler btnTxt="Generate" loading={loading} />

            <Button
              className="btn-lg ms-3"
              color="secondary"
              type="button"
              onClick={handlePreviewClick}
            >
              Preview
            </Button>

            <ResultHandler
              error={error}
              success={success}
              successMsg={"Created Successfully!"}
            />
          </Form>
        </Container>
      </div>
    </>
  );
};

export default AddInvoice;
